import { render, staticRenderFns } from "./DAudioUploadPreview.vue?vue&type=template&id=1245268f&"
import script from "./DAudioUploadPreview.vue?vue&type=script&lang=js&"
export * from "./DAudioUploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./DAudioUploadPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports